import { render } from "./TypeFilter.vue?vue&type=template&id=61c5a7fb&scoped=true"
import script from "./TypeFilter.vue?vue&type=script&lang=js"
export * from "./TypeFilter.vue?vue&type=script&lang=js"

import "./TypeFilter.vue?vue&type=style&index=0&id=61c5a7fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c5a7fb"]])

export default __exports__